import "./../styles/main.scss";
// JQuery Ecosystem
import $ from "jquery";
require("./helpers/jQueryPlugins");
require("jquery.scrollto");
require("./plyr");
import gsap from "gsap";
const axios = require('axios').default;
// Ui item
import GLightbox from "glightbox";
import { carouselWrapper } from "./helpers/CarouselWrapper";
import mapPage from "./Components/MapPage";
// Woocommerce
// require('./woocommerce/Global');
// GDPR Custom System
require('./helpers/CookieConsent');
// Controllers
// require("./helpers/newsletterController");
// Required ReactElements
require("./Components/SearchForm");
require("./Components/ListItem");
// Define all actions
let Site = {
    // Plugins
    carousel: carouselWrapper,
    // slider: sliderWrapper,
    // Actions
    init: () => {
        Site.global();
    },
    transition: (response) => {
        Site.global();
        Site.scripts(response);
    },
    global: () => {
        Site.carousel();
        // Site.slider();
        GLightbox({
            touchNavigation: false,
            touchFollowAxis: false,
            keyboardNavigation: false,
        });
        if ($("#map").length) {
            mapPage();
        }
    },
    scripts: (response) => {
        var initialized_scripts = [];
        var script_tags = document.getElementsByTagName("script");
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                initialized_scripts.push(src);
            }
        });
        var new_imports = [];
        var new_evaluations = '';
        var script_tags = $(response).find('script');
        $(script_tags).each(function (i, s) {
            var src = $(s).attr('src');
            if (src) {
                // if not already initialized add it
                if (initialized_scripts.indexOf(src) == -1) {
                    new_imports.push(src);
                }
            }
            else {
                // it is an inline script, will evaluate it
                new_evaluations += script_tags[i].innerHTML;
            }
        });
        $.getMultiScripts(new_imports).done(function () {
            eval(new_evaluations);
        }).fail(function (error) {
            // one or more scripts failed to load
        }).always(function () {
            // always called, both on success and error
        });
    }
};
// barba.init({
//     views: [],
//     transitions: [{
//         name: 'opacity-transition',
//         async leave({ current, next, trigger }) {
//             const done = this.async();
//             $('.show-menu').removeClass("show-menu");
//             te.toggle().eventCallback("onComplete", () => {
//                 gsap.to(current.container, {
//                     opacity: 0
//                 }).eventCallback("onComplete", () => {
//                     done();
//                 });
//             });;
//         },
//         after(data) {
//             let parser = new DOMParser();
//             let htmlDoc = parser.parseFromString(data.next.html.replace(/(<\/?)body( .+?)?>/gi, '$1notbody$2>', data.next.html), 'text/html');
//             let bodyClasses = htmlDoc.querySelector('notbody').getAttribute('class');
//             let dataPid = $(htmlDoc).find('notbody').data("pid");
//             document.body.setAttribute('class', bodyClasses);
//             $(window).scrollTo(0);
//             $("#main-header").find(".current-menu-item").removeClass("current-menu-item");
//             let newMenu = $("#main-header").find(".menu-item[data-pid="+ dataPid +"]");
//             if (newMenu.length) {
//                 newMenu.addClass("current-menu-item");
//             }
//             gsap.from(data.next.container, {
//                 opacity: 0
//             });
//             te.toggle().eventCallback("onComplete", () => {
//                 te.removeScreen();
//                 Site.transition(htmlDoc);
//             });
//         }
//     }]
// });
$(document).ready(function () {
    Site.init();
    let menu = gsap.timeline({ paused: true, onComplete: () => {
        }, onReverseComplete: () => {
        } });
    menu
        .to("#nav", { left: 0, duration: 0.4, ease: "power2.out" })
        .to("#nav > a", { opacity: 1, duration: 0.2, ease: "power2.out" }, ">-0.15")
        .to("#nav > .header-nav > li", { stagger: 0.1, opacity: 1, y: 0, duration: 0.2, ease: "power2.out" }, ">-0.1")
        .to("#nav > .language-wrapper", { opacity: 1, duration: 0.2, ease: "power2.out" });
    $("#main-header").on("click", ".actions .menu > a", (e) => {
        e.preventDefault();
        menu.play();
    });
    $("#nav").on("click", "a[href='#close-menu']", (e) => {
        e.preventDefault();
        menu.reverse();
    });
    $('body').on("click", ".shared-item", (e) => {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", ".goTo", (e) => {
        e.preventDefault();
        const elm = $(e.currentTarget).attr("href");
        if ($(elm).length) {
            const posY = $(elm).offset().top - ($("#main-header").height() + 20);
            $.scrollTo(posY, 400);
        }
    });
});
